"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importDefault(require("@seaweb/coral/hoc/styled"));
var BaseButton_1 = __importDefault(require("@seaweb/coral/components/BaseButton/BaseButton"));
var Ripple_1 = __importDefault(require("@seaweb/coral/components/Ripple/Ripple"));
var useWrapEvent_1 = __importDefault(require("@seaweb/coral/hooks/useWrapEvent"));
var ThemeProvider_1 = require("@seaweb/coral/components/ThemeProvider");
var forwardAs_1 = __importDefault(require("@seaweb/coral/hoc/forwardAs"));
var WrappedBaseButton = forwardAs_1.default(BaseButton_1.default, ['radius']);
var RelativeBaseButton = styled_1.default(WrappedBaseButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  transition: all 0.2s ease;\n  border-radius: ", ";\n"], ["\n  position: relative;\n  transition: all 0.2s ease;\n  border-radius: ", ";\n"])), function (props) { return props.radius; });
var RippleButton = react_1.forwardRef(function RippleButton(_a, ref) {
    var as = _a.as, colorType = _a.colorType, color = _a.color, r = _a.radius, children = _a.children, disabled = _a.disabled, rippleDisabled = _a.rippleDisabled, rippleIntensity = _a.rippleIntensity, onRelease = _a.onRelease, props = __rest(_a, ["as", "colorType", "color", "radius", "children", "disabled", "rippleDisabled", "rippleIntensity", "onRelease"]);
    var rippleRef = react_1.useRef(null);
    var handleRelease = useWrapEvent_1.default(onRelease, function () {
        if (!disabled && !rippleDisabled) {
            rippleRef.current.createRipple();
        }
    });
    var radius = ThemeProvider_1.useRadius(r);
    return (react_1.default.createElement(RelativeBaseButton, __assign({ _as: as, ref: ref, disabled: disabled, onRelease: handleRelease, radius: radius }, props),
        children,
        react_1.default.createElement(Ripple_1.default, { ref: rippleRef, radius: radius, color: color, colorType: colorType, intensity: rippleIntensity })));
});
exports.default = react_1.memo(RippleButton);
var templateObject_1;
